import * as React from 'react';

const SvgManufacturerLogo = props => (
  <svg
    height={37}
    viewBox="0 0 79 37"
    width={79}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <defs>
      <clipPath id="ManufacturerLogo_svg__a">
        <path
          d="M0 0h79v37H0z"
          data-name="Rectangle 82"
          fill="#b9b9b9"
          transform="translate(.039 -.001)"
        />
      </clipPath>
    </defs>
    <g data-name="Group 1771">
      <g
        clipPath="url(#ManufacturerLogo_svg__a)"
        data-name="Group 1770"
        fill="#b9b9b9"
        transform="translate(-.039)"
      >
        <path
          d="M66.642-.236a8.241 8.241 0 0 1 1.271.594 2.819 2.819 0 0 1 1.27 2.415q.019 9.867.006 19.734a3.032 3.032 0 0 1-3.037 3.017 9.531 9.531 0 0 1-1.272-.022 3.061 3.061 0 0 1-2.725-3.125c-.008-3.313 0-6.627 0-9.94V3.525c0-2.211.5-2.959 2.53-3.761Zm1.393 19.311c0-1.11.006-2.219 0-3.329-.005-.736-.411-1.107-1.185-1.106a1.04 1.04 0 0 0-1.192 1.11q-.011 3.28 0 6.56a1.082 1.082 0 0 0 1.223 1.148 1.048 1.048 0 0 0 1.154-1.151c.005-1.077 0-2.154 0-3.231"
          data-name="Path 4051"
        />
        <path
          d="M55.666 37.201c-.259-.089-.527-.157-.775-.269a2.915 2.915 0 0 1-1.875-2.791q-.024-9.817-.009-19.634a3.032 3.032 0 0 1 3.065-3.08 7.851 7.851 0 0 1 1.416.049 3.058 3.058 0 0 1 2.552 3.174q.011 4.774.011 9.548v9.646a3.08 3.08 0 0 1-2.59 3.3.626.626 0 0 0-.129.066Zm.836-6.468h.012v3.08c0 .881.4 1.315 1.2 1.308.776-.007 1.186-.448 1.186-1.287q0-3.178-.007-6.355a1.2 1.2 0 0 0-2.394-.021c-.009 1.092 0 2.184 0 3.276"
          data-name="Path 4052"
        />
        <path
          d="m78.599 34.262-.11.372a2.952 2.952 0 0 1-2.52 2.291 6.533 6.533 0 0 1-1.755.017 3.006 3.006 0 0 1-2.675-3.055c-.009-1.176 0-2.351 0-3.527V14.538a3.061 3.061 0 0 1 3.332-3.31 5.849 5.849 0 0 1 1.36.1 2.964 2.964 0 0 1 2.264 2.322l.106.424Zm-1.171-3.733c0-1.094.005-2.188 0-3.281a1.052 1.052 0 0 0-1.2-1.152 1.038 1.038 0 0 0-1.186 1.162q-.008 3.232 0 6.464a1.061 1.061 0 0 0 1.172 1.189 1.084 1.084 0 0 0 1.219-1.2v-3.183"
          data-name="Path 4053"
        />
        <path
          d="M0 18.875h2.556v14.147c0 .2 0 .392.013.587a.723.723 0 0 0 .78.758c.129 0 .258.017.422.029v2.375a2.933 2.933 0 0 1-3.7-2.336.558.558 0 0 0-.071-.173V18.875"
          data-name="Path 4054"
        />
        <path
          d="M46.19 36.824h-2.467v-9.068c0-1.037-.622-1.558-1.557-1.34a1.311 1.311 0 0 0-1.012 1.376q-.005 4.238 0 8.476v.551h-2.529V27.846a1.315 1.315 0 0 0-.944-1.427 1.279 1.279 0 0 0-1.62 1.329c-.008 2.613 0 5.226 0 7.839v1.214h-2.509v-12.79h2.5v1a2.891 2.891 0 0 1 4.73.059 3.2 3.2 0 0 1 1.846-1.2 2.927 2.927 0 0 1 3.61 2.877c.055 3.314.014 6.63.012 9.945a.522.522 0 0 1-.05.129"
          data-name="Path 4055"
        />
        <path
          d="M16.901 29.382c.94-1.653 1.887-3.3 2.812-4.962a.721.721 0 0 1 .761-.449c.66.038 1.324.01 2.05.01-.1.193-.163.32-.235.442-.828 1.4-1.647 2.814-2.493 4.207a.855.855 0 0 0-.053.931c1.083 2.263 2.136 4.541 3.2 6.814.061.13.12.26.215.467-.935 0-1.808.016-2.68-.018-.123 0-.28-.237-.346-.4-.687-1.655-1.358-3.316-2.081-5.091-.5 1.021-1.423 1.723-1.249 2.985a18.624 18.624 0 0 1 .02 2.48h-2.489V18.867h2.473v10.485Z"
          data-name="Path 4056"
        />
        <path
          d="M28.998 29.087c0-.5.01-.921 0-1.343a1.269 1.269 0 0 0-2.5-.4c-.026.075-.047.153-.072.236h-2.485a3.707 3.707 0 0 1 2.975-3.69 3.8 3.8 0 0 1 4.6 3.65c.036 3 .009 6.009.007 9.014 0 .063-.012.127-.022.229h-2.469v-1.18c-.171.2-.259.3-.343.4a2.689 2.689 0 0 1-4.778-1.576 34.41 34.41 0 0 1-.013-2.057 3.209 3.209 0 0 1 3.189-3.28c.617-.028 1.236 0 1.913 0m0 2.155a14.6 14.6 0 0 0-1.5.01 1.028 1.028 0 0 0-1.025.944 5.84 5.84 0 0 0 0 1.124 1.261 1.261 0 0 0 2.514-.07c.028-.651.006-1.3.006-2.009"
          data-name="Path 4057"
        />
        <path
          d="M12.426 31.315H7.46c0 .733-.026 1.415.009 2.094a1.2 1.2 0 0 0 1 1.013 1.186 1.186 0 0 0 1.288-.591 6.438 6.438 0 0 0 .282-.7h2.474a3.807 3.807 0 0 1-1.784 3.294 3.733 3.733 0 0 1-5.731-2.74 55.059 55.059 0 0 1-.046-6.265 3.8 3.8 0 0 1 6.077-2.835 3.163 3.163 0 0 1 1.371 2.291c.1 1.456.026 2.924.026 4.44m-4.97-2.118h2.567A17.145 17.145 0 0 0 9.9 27.32a1.107 1.107 0 0 0-1.277-.941 1.226 1.226 0 0 0-1.161 1.167c-.025.534-.005 1.071-.005 1.652"
          data-name="Path 4058"
        />
      </g>
    </g>
  </svg>
);

export default SvgManufacturerLogo;

